import React from 'react';
import cn from 'classnames';
import styles from './CheckboxSwitcher.scss';

const CheckboxSwitcher = ({ enabled, onToggle, text }) => (
  <div className={styles.Container}>
    <span className={styles.CheckboxSwitcherText}>{text}</span>
    <span
      className={cn(styles.CheckboxSwitcher, {
        [styles.Enabled]: enabled,
      })}
      onClick={onToggle}
    >
      <span className={styles.Marker}></span>
    </span>
  </div>
);

export default CheckboxSwitcher;



// WEBPACK FOOTER //
// ./src/components/common/CheckboxSwitcher/CheckboxSwitcher.js